module.exports = __webpack_public_path__ + "static/media/map-spain-en.bba03dba.png";